import useAppMutation from 'hooks/useAppMutation';
import useAppUser from 'hooks/useAppUser';
import { UpdateCustomDataFieldsInternalPayload } from 'models/CustomDataField';
import API from 'services/API';

export const UPDATE_INTERNAL_CUSTOM_DATA_FIELDS_MUTATION_KEY =
  'update-internal-custom-data-fields';

const useUpdateInternalCustomDataFields = () => {
  const { agencyUid } = useAppUser();

  const {
    mutateAsync: updateInternalCustomFields,
    isLoading: isUpdatingInternalCustomField,
  } = useAppMutation(
    [UPDATE_INTERNAL_CUSTOM_DATA_FIELDS_MUTATION_KEY],
    ({ customDataFields }: UpdateCustomDataFieldsInternalPayload) => {
      return API.post<UpdateCustomDataFieldsInternalPayload>(
        '/api/internal/custom-data-fields/batch-upsert',
        {
          agencyUid,
          customDataFields,
        },
      );
    },
  );

  return {
    updateInternalCustomFields,
    isUpdatingInternalCustomField,
  };
};

export default useUpdateInternalCustomDataFields;
